import { InfoCard } from '@backstage/core-components';
import { ScoreRuleLabels } from '@internal/ui-common';
import { scoreRules } from '../../utils/scoreRules';
import { useRef } from 'react';

import { Divider, Link, Typography } from '@material-ui/core';

export const SecretsRotationGuideCard = () => {
  const guideLink = useRef({
    text: 'security guidelines',
    link: 'https://zf-scalar.atlassian.net/wiki/spaces/OD/pages/3212944244/SGPR-+Management+of+secrets+key+rotation',
  });
  return (
    <InfoCard variant="gridItem" title="Recommended Action">
      <Typography component="span" variant="body1" color="textSecondary">
        In line with our{' '}
        <Link href={guideLink.current.link} underline="always">
          {guideLink.current.text}
        </Link>
        , secrets must be rotated annually. This dashboard displays the secrets
        owned by your team and highlights those that require rotation.
        <p />
        <Divider />
        <ScoreRuleLabels scoreRules={scoreRules} />
      </Typography>
    </InfoCard>
  );
};
